module.exports = __webpack_public_path__ + "static/img/1.c7d0302.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Seguro-trans-mercancias-especifico/1.png
// module id = DujT
// module chunks = 0